export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-stack-overflow-33e8fc8323e39d64b13c77374f811298.svg";